import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Typography, 
  Button, 
  Box,
  Container,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const RegisterSuccess = () => {
  const navigate = useNavigate();
  
  const handleLogin = () => {
    navigate('/login');
  };
  
  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <CheckCircleIcon 
          color="success" 
          sx={{ fontSize: 80, mb: 2 }} 
        />
        
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'center' }}>
          Registration Successful!
        </Typography>
        
        <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
          Congratulations! Your registration has been completed successfully.
        </Typography>
        
        <Card sx={{ width: '100%', mb: 4, boxShadow: 3 }}>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              What happens next?
            </Typography>
            
            <List>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Your application has been submitted" 
                  secondary="Our admin team will review your profile information"
                />
              </ListItem>
              <Divider component="li" />
              
              <ListItem>
                <ListItemIcon>
                  <InfoIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Account verification" 
                  secondary="We may contact you to verify your credentials and expertise"
                />
              </ListItem>
              <Divider component="li" />
              
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Approval and activation" 
                  secondary="After approval, we'll send you an email to activate your account"
                />
              </ListItem>
            </List>
          </CardContent>
        </Card>
        
        <Box sx={{ bgcolor: 'background.paper', p: 3, borderRadius: 2, mb: 4, width: '100%' }}>
          <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
            Important Note:
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You can now sign in to your account with the email and password you provided.
            However, your astrologer profile will be visible to clients only after admin approval.
          </Typography>
        </Box>
        
        <Button 
          variant="contained" 
          color="primary" 
          size="large" 
          onClick={handleLogin}
          fullWidth
        >
          Go to Login
        </Button>
      </Box>
    </Container>
  );
};

export default RegisterSuccess;
